/*
 * Currently this component is only handling breadcrumbs for folder hierarchy 
 */
import { Component, OnInit, Input, SimpleChange, OnChanges, SimpleChanges } from '@angular/core';
import { Folder } from '../../models/site-content/folder.model';
import { BaseViewComponent } from '../list-view/base-view/base-view.component';
import { MatDialog } from '@angular/material/dialog';
import { Breadcrumb } from '../../models/breadcrumb.model';
import { ListItemDragActionData } from '../list-view/list-view-drag-action.model';
import { UtilityHelper } from '../../utility.helper';
import { DragDropService } from '../../services/drag-drop.service';
import { FormInstance } from '../../models/site-content/form-instance.model';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent extends BaseViewComponent implements OnInit, OnChanges {

    @Input() currentFolder: Folder;
    @Input() currentFormInstance: FormInstance;
    @Input() dragEvent: ListItemDragActionData;
    static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumbLabel';
    breadcrumbs: Breadcrumb[];

    constructor(public dialog: MatDialog,
        public injectedDragDropService: DragDropService) {
        super(dialog, injectedDragDropService);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currentFolder) {
            this.buildFolderBreadcrumbs(changes.currentFolder.currentValue);
        } else if (changes.currentFormInstance) {
            this.buildFolderBreadcrumbs(this.currentFolder);
        }
    }

    ngOnInit() {
        this.buildFolderBreadcrumbs(this.currentFolder);
    }

    private buildFolderBreadcrumbs(folder: Folder): void {
        this.breadcrumbs = [];

        let folderIsRoot = !folder.parentFolderId;
        // Removed this behavior for VNEXT-659
        //if (folderIsRoot && this.currentFormInstance == null) {
        //    return;
        //}

        let dataCollectionId = folder.dataCollectionId;

        this.breadcrumbs.push(new Breadcrumb('Site Structure', this.buildFolderUrl(dataCollectionId), -1));
        let ancestors = folder.ancestorFolders.filter(f => f.parentFolderId != null);

        let url: string;
        for (let ancestor of ancestors) {
            url = this.buildFolderUrl(dataCollectionId, ancestor);
            this.breadcrumbs.push(new Breadcrumb(ancestor.name, url, ancestor.id));
        }

        let folderIsNotCurrent = folder.id != this.currentFolder.id;
        if (!folderIsRoot) { // && (folderIsNotCurrent || this.currentFormInstance) Removed for VNEXT-659
            url = this.buildFolderUrl(dataCollectionId, folder);
            this.breadcrumbs.push(new Breadcrumb(folder.name, url, folder.id));
        }
    }

    private buildFolderUrl(dataCollectionId: number, folder: Folder = null) {
        let base = `/site/${dataCollectionId}/structure`;
        if (folder == null) {
            return base;
        } else {
            return `${base}/folder/${folder.id}`;
        }
    }
}
